<div class="card">
  <div class="card-header text-center">
    <img
      class="img-responsive d-block mx-auto"
      src="assets/images/nantellogo.png"
    />
  </div>
  <div class="card-body">
    <p>
      For additional assistance, you may contact the NANTeL Help Desk at
      (770)644-8900 or send an email to
      <a href="mailto:nantelhelpdesk@inpo.org">nantelhelpdesk@inpo.org</a>
    </p>
  </div>
</div>
